<template>
  <div class="content-tab syspassword">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="content-item">
          <div class="formRow">
            <div class="forminput">
              <form>
                <div class="table">
                  <div class="dt-r">
                    <div class="title dt-c">{{$t('systemPwd.currentPwd')}}</div>
                    <div class="forminput password dt-c">
                      <input name="currentPassword" v-model="currentPassword" class="form-control" @keyup="onChange" :type="showPassword" v-validate="'password|max:20'" maxlength="20" size="20" @focus="getFocus('current')" autocomplete="off">
                      <span class="div-password-eye icon-view" :class="{'active': showPassword==='text'}" @click="onShowPasswordClick()">
                      </span>
                    </div>
                  </div>
                </div>
                <div class="table">
                  <div class="dt-r">
                    <div class="title dt-c">{{$t('systemPwd.newPwd')}}</div>
                    <div class="forminput password dt-c">
                      <input name="Password" v-model="newPassword" class="form-control" :type="showNewPassword" v-validate="'required|password|max:20|min:8'" maxlength="20" size="20" :class="{'error': errors.has('Password') || isDefault}" @keyup="checkValidation" @focus="getFocus('newpassword')" autocomplete="off">
                      <span class="div-password-eye icon-view" :class="{'active': showNewPassword==='text'}" @click="onShowNewPasswordClick()">
                      </span>
                      <span v-if="checkEmpty && !isDefault && !errors.has('Password')" class="div-password-tick icon-tick"></span>
                    </div>
                  </div>
                  <div class="dt-r">
                    <div class="dt-c"></div>
                    <div v-show="errors.has('Password') || isDefault" class="errorMessage dt-c">{{ (isDefault) ? defaultMsg : setErrorMsg(errors.first('Password')) }}</div>
                  </div>
                </div>
                <div class="table">
                  <div class="dt-r">
                    <div class="title dt-c">{{$t('systemPwd.confirmPwd')}}</div>
                    <div class="forminput password dt-c">
                      <input name="Password2" v-model="newPassword2" class="form-control" :type="showNewPassword2" v-validate="'required|password|max:20|min:8'" maxlength="20" size="20" :class="{'error': (errors.has('Password2') || !isMatch) && newPassword2}" @keyup="checkValidation" @focus="getFocus('newpassword')" autocomplete="off">
                      <span class="div-password-eye icon-view" :class="{'active': showNewPassword2==='text'}" @click="onShowNewPassword2Click()"></span>
                      <span v-if="checkConsistent" class="div-password-tick icon-tick"></span>
                    </div>
                  </div>
                  <div class="dt-r">
                    <div class="dt-c"></div>
                    <div v-if="(errors.has('Password2') || !isMatch) && newPassword2" class="errorMessage dt-c">{{(isMatch)? setErrorMsg(errors.first('Password2')) : notMatchMsg }}</div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </scrollbar>
      <div class="content-body-footer">
        <button :disabled="isDisabled" class="q-button blue-btn-full right" :title="$t('save')" @click="onSaveClick()">{{$t('save')}}</button>
      </div>
    </div>
    <LogoutWarning :onChange="onLogout"/>
    <modal class="popup_dialog alert" name="modal-alert" :class="ifTop"
       transition="nice-modal-fade"
       :width="300"
       :min-width="300"
       height="200"
       :delay="100"
       :draggable="'.modal-header'"
       :clickToClose="false"
       :adaptive="true"
       classes='q-v--modal'>
      <div class="modal-content">
        <div class="modal-header">
          {{$t('systemPwd.change')}}
        </div>
        <div class="icon-btn_close modal-close" @click="onClose()"></div>
        <div class="modal-body">
          <div class="modal-container">
            <div class="message">
              {{ isCurrentInvalid ? $t('systemPwd.invalid') : $t('systemPwd.changeFail')}}
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="footer-left">
          </div>
          <div class="footer-right">
            <button class="q-button blue-btn-full" @click="onClose()" :title="$t('ok')">{{$t('ok')}}</button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue'
import Encrypt from '../util/encrypt'
import info from './module/InfoTips'
import LogoutWarning from './LogoutWarning'
import {
  mapState,
  mapGetters,
  mapActions,
  mapMutations
} from 'vuex'
export default {
  name: 'SystemPassword',
  components: {
    info,
    LogoutWarning
  },
  data () {
    return {
      modalname: 'modal-alert',
      currentPassword: '',
      newPassword: '',
      newPassword2: '',
      showPassword: 'password',
      showNewPassword: 'password',
      showNewPassword2: 'password',
      isDisabled: false,
      isShowLoading: true,
      isShowInfo: false,
      isMatch: true,
      isCurrentInvalid: false,
      notMatchMsg: this.$t('systemPwd.notMatch'),
      isDefault: false,
      defaultMsg: this.$t('login.defaultMsg'),
      focusInput: ''
    }
  },
  created () {
    let me = this
    this.$validator.extend('password', {
      getMessage (field, val) {
        return me.$t('errorMessage.password')
      },
      validate (value, field) {
        // eslint-disable-next-line no-useless-escape
        var temp = (me.focusInput === 'current') ? /^[A-Za-z\d~!@#$%^&*()_+=\-`[\]\\{}|;':",./<>? ]{0,20}$/ : /^[A-Za-z\d~!@#$%^&*()_+=\-`[\]\\{}|;':",./<>? ]{8,20}$/
        if (!temp.test(value)) {
          return false
        }
        return true
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('updateInfoTips', false)
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  mounted: async function () {
    this.onChange()
  },
  watch: {
    newPassword: function (value) {
      // this.onChange()
    },
    newPassword2: function (value) {
      // this.onChange()
    },
    isDisabled: function (value) {
      this.$store.commit('updateDataChanged', !value)
    }
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal'
    ]),
    onShowPasswordClick: function () {
      this.showPassword === 'password' ? (this.showPassword = 'text') : (this.showPassword = 'password')
    },
    onShowNewPasswordClick: function () {
      this.showNewPassword === 'password' ? (this.showNewPassword = 'text') : (this.showNewPassword = 'password')
    },
    onShowNewPassword2Click: function () {
      this.showNewPassword2 === 'password' ? (this.showNewPassword2 = 'text') : (this.showNewPassword2 = 'password')
    },
    onSaveClick: function () {
      if (!this.checkCurrentPwd()) {
        this.onOpen()
      } else {
        this.isShowLoading = true
        this.setUserPassword(this.newPassword2).then(async res => {
          if (res.data.error_code === 200) {
            // this.$store.commit('updateDataChanged', false)
            this.isDisabled = true
            this.isShowLoading = false
            this.$log.info('setUserPassword pass')
            this.$store.commit('setLoadingType', 'logout')
            this.$store.commit('updateFullLoadingStatus', true)
            this.openModal('logout-modal-alert')
            this.$modal.show('logout-modal-alert')
          } else {
            this.isShowLoading = false
            this.onOpen()
          }
        }).catch((error) => {
          this.$log.error(error)
          this.isShowLoading = false
          this.onOpen()
        })
      }
    },
    checkValidation: async function () {
      let mac = (this.sysBoard) ? this.sysBoard.MacAddr.split(':') : ''
      let tempPwd = mac.join('')
      await this.$validator.validateAll().then(async result => {
        if (!result) {
          this.isDisabled = !result
        } else {
          if (this.newPassword !== '' && !this.newPassword === tempPwd) {
            this.isDisabled = true
            this.isDefault = true
          } else {
            this.isDefault = false
            await this.onChange()
          }
        }
      }).catch(() => {
        this.isDisabled = true
      })
    },
    checkCurrentPwd: function () {
      const value = this.currentPassword
      const sid = (Vue.cookie.get('QSW_SID')) ? Vue.cookie.get('QSW_SID').split('::')[1] : Vue.cookie.get('QSW_SID')
      const pwd = btoa(value) ? btoa(value) : Encrypt.ezEncode(encodeURIComponent(value))
      let result = false
      if (sid === pwd) {
        result = true
      }
      this.isCurrentInvalid = !result
      return result
    },
    onChange: function () {
      this.isShowLoading = false
      if (this.currentPassword !== '') {
        if (this.newPassword !== '' && this.newPassword2 !== '' && this.newPassword === this.newPassword2) {
          this.isMatch = true
          this.isDisabled = false
        } else {
          this.isMatch = false
          this.isDisabled = true
        }
        if (this.newPassword === '' && this.newPassword2 === '') {
          this.isMatch = true
        }
      } else {
        this.isDisabled = true
      }
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose () {
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
    },
    onLogout () {
      this.postLogout()
    },
    setErrorMsg: function (data) {
      let message = data
      if (data) {
        if (data.indexOf('required') > -1) {
          message = this.$t('errorMessage.password')
        }
      }
      return message
    },
    getFocus: function (val) {
      this.focusInput = val
    },
    ...mapActions(['setUserPassword', 'postLogout'])
  },
  computed: {
    ...mapGetters(['getTopModalName']),
    ...mapState({
      isDataChanged: state => state.app.isDataChanged,
      showInfoTips: state => state.app.showInfoTips,
      sysBoard: state => state.module.sysBoard,
      fwinfo: state => state.module.fwinfo
    }),
    checkEmpty: function () {
      if (this.$validator.errors.has('password')) {
        return false
      } else {
        if (this.newPassword !== '') {
          return true
        } else {
          return false
        }
      }
    },
    checkConsistent: function () {
      if (this.newPassword !== '' && this.newPassword2 !== '' && this.newPassword === this.newPassword2) {
        return true
      } else {
        return false
      }
    },
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)
      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.content-tab.syspassword {
  position: relative;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  >.content-body {
    padding: 20px 10px 10px 10px;
    .content-item >.formRow {
      &.static {
        margin-top: 10px;
      }
      .forminput {
        .table {
          position: relative;
          display: table;
          .title {
            font-size: 14px;
            color: #000000;
            line-height: 22px;
            font-weight: 500;
            width: 165px;
            font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
          }
          .forminput.password {
            position: relative;
            input {
              padding: 0px 25px 0px 10px;
              width: 200px;
              font-size: 14px;
              color: #000000;
              line-height: 30px;
              height: 30px;
              border: 1px solid #979797;
              border-radius: 4px;
              font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
            }
            .div-password-eye {
              cursor: pointer;
              color: #7F7F7F;
              position: absolute;
              font-size: 14px;
              top: 8px;
              left: 180px;
              &:hover {
                color: #000000;
              }
              &.active {
                color: #000000;
              }
            }
          }
          .div-password-tick {
            line-height: 30px;
            color: #7ED321;
            background-size: cover;
            position: relative;
            font-size: 13px;
            left: 10px;
            &.left {
              left: 30px;
            }
          }
          .icon-info {
            background-size: cover;
            position: relative;
            line-height: 30px;
          }
        }
      }
    }
    .content-body-footer {
      top: calc(100% - 50px) !important;
      .q-button {
        min-width: 80px;
        font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
      }
    }
    .scrollbar-body {
      height: calc(100% - 40px);
      padding: 0px 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SystemPassword.vue